import React from "react";
import { AlertCircleIcon } from "Components/atoms/icons";

interface ErrorStateProps {
    title?: string;
    subtitle?: string;
    action?: React.ReactNode;
}

const ErrorState: React.FC<ErrorStateProps> = ({
    title = "Something went wrong",
    subtitle = "Please try again later.",
    action
}) => {
    return (
        <div className="state-container">
            <div className="state-icon"><AlertCircleIcon className="text-warning" /></div>
            <h4 className="state-title">{title}</h4>
            <p className="state-subtitle">{subtitle}</p>
            {action && <div className="error-state-action">{action}</div>}
        </div>
    );
};

export default ErrorState;
